class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)

class MobileNavTouchHighlighter {
	constructor(root) {
		this.root = root
		this.activeItem = null
		this.clearTimer = null
		this.onTouchStart = this.onTouchStart.bind(this)
		this.onTouchMove = this.onTouchMove.bind(this)
		this.onTouchEnd = this.onTouchEnd.bind(this)

		this.root.addEventListener('touchstart', this.onTouchStart, { passive: true })
		this.root.addEventListener('touchmove', this.onTouchMove, { passive: true })
		this.root.addEventListener('touchend', this.onTouchEnd, { passive: true })
		this.root.addEventListener('touchcancel', this.onTouchEnd, { passive: true })
	}

	findItemAtPoint(x, y) {
		const target = document.elementFromPoint(x, y)
		const item = target?.closest('.f-mobile-nav__item')
		return item && this.root.contains(item) ? item : null
	}

	setActiveItem(item) {
		if (item === this.activeItem) return
		this.activeItem?.classList.remove('is-touch-highlighted')
		this.activeItem = item
		this.activeItem?.classList.add('is-touch-highlighted')
	}

	onTouchStart(event) {
		window.clearTimeout(this.clearTimer)
		const touch = event.touches[0]
		if (touch) this.setActiveItem(this.findItemAtPoint(touch.clientX, touch.clientY))
	}

	onTouchMove(event) {
		const touch = event.touches[0]
		if (touch) this.setActiveItem(this.findItemAtPoint(touch.clientX, touch.clientY))
	}

	onTouchEnd() {
		window.clearTimeout(this.clearTimer)
		this.clearTimer = window.setTimeout(() => this.setActiveItem(null), 140)
	}
}

document.querySelectorAll('.f-mobile-nav__inner').forEach((root) => {
	new MobileNavTouchHighlighter(root)
})
